import { InjectionToken } from '@angular/core';
import { AppRoutes } from '../interfaces/app-routes.interface';

export const APP_ROUTES = new InjectionToken<AppRoutes>('Application routes');
